import { usePathname } from "next/navigation";
import Link from "next/link";
import clsx from "clsx";
import React from "react";
import { toast } from "react-toastify";

const SaveMapButton = ({ user, homepageOnly }) => {
  const [showUserMenu, setShowUserMenu] = React.useState(false);

  const pathName = usePathname();

  if (homepageOnly && pathName !== '/') {
    return null;
  }

  if (!user) {
    return (
      <>
        {!pathName.startsWith('/login') && (
          <div
            onClick={() => {
              toast.info("You must log in to save maps",
                {
                  toastId: 'LOGIN_REQUIRED',
                  theme: 'dark',
                  hideProgressBar: true,
                  autoClose: 5000,
                  closeOnClick: false,
                }
              );
            }}
            className={clsx(
              homepageOnly
                ? 'mr-4 mt-1 text-shades-text/60 hover:brightness-125'
                : 'text-shades-baseLight hover:brightness-150 transition-all duration-100 ease-in-out',
              'block cursor-pointer font-semibold tracking-wider z-[50] mr-2 whitespace-nowrap text-[14px]'
            )}
          >
            Save map
          </div>
        )}
      </>
    );
  }

  return null;
};

export default SaveMapButton;
